export default "__VITE_ASSET__Dz7ETqIl__"